<template>
  <transition name="backtop-fade">
    <button v-show="visible" type="button" class="back-to-top" aria-label="回到顶部"
      :style="{ right: `${right}px`, bottom: `${bottom}px` }" @click="scrollToTop">
      <el-tooltip content="回到顶部" placement="top" effect="dark"  append-to-body>
        <i class="back-to-top__icon" aria-hidden="true" />
      </el-tooltip>
    </button>
  </transition>
</template>

<script>
export default {
  name: "BackToTop",
  props: {
    visibilityHeight: {
      type: Number,
      default: 300,
    },
    right: {
      type: Number,
      default: 8,
    },
    bottom: {
      type: Number,
      default: 80,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    this.onScroll = () => {
      const top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      this.visible = top >= this.visibilityHeight;
    };
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.back-to-top {
  position: fixed;
  z-index: 2000;
  width: 44px;
  height: 44px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background-color: #00afaf;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 175, 175, 0.35);
  transition: background-color 0.2s, box-shadow 0.2s, transform 0.2s;
}

.back-to-top:hover {
  background-color: #009a9a;
  box-shadow: 0 6px 16px rgba(0, 175, 175, 0.45);
  transform: translateY(-2px);
}

.back-to-top:active {
  transform: translateY(0);
}

.back-to-top__icon {
  display: block;
  width: 0;
  height: 0;
  margin: 0 auto;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 10px solid #fff;
  transform: translateY(-1px);
}

.backtop-fade-enter-active,
.backtop-fade-leave-active {
  transition: opacity 0.25s, transform 0.25s;
}

.backtop-fade-enter,
.backtop-fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
